import { definedMap, withDefault } from "collection-utils";
import { Data } from "common/components/data";
import type { AppEnvironment, AppOther, RenderEnvironment } from "common/components/types";
import { getDocURL } from "common/docUrl";
import { shareScreenName } from "component-utils/screen-names";
import { getPlayLinkForCurrentLocation } from "routes";

export function getIdealShareUrl(env: AppEnvironment): string {
    // We expect that if the app isn't published, it's only ever running in the builder.
    // We swap the documentation for app publishing in instead of a non-functional link
    // so that there's a chance that developers realize that they aren't quite finished.
    if (!env.isPublished) {
        return getDocURL("publishYourApp");
    }
    let defaultURL = definedMap(env.customDomain, cd => `https://${cd}`);
    if (defaultURL === undefined) {
        defaultURL = definedMap(env.shortName, sn => `https://${sn}`);
    }
    return withDefault(getPlayLinkForCurrentLocation(defaultURL), window.location.href);
}

export function pushShareScreen(renderEnv: RenderEnvironment) {
    renderEnv.appEnvironment.pushModalBuilderScreen(
        shareScreenName,
        Data.fromJSON<AppOther, AppEnvironment>({ displayQRCode: false }),
        undefined,
        undefined
    );
}
